import cn from 'classnames';
import { CloseButtonProps } from './closeButton.props';
import styles from './closeButton.module.scss';

export const CloseButton = ({
  className,
  ...rest
}: CloseButtonProps): JSX.Element => {
  const moduleStyles = cn(styles.module, className);

  return <button className={moduleStyles} {...rest} />;
};
